import { render, staticRenderFns } from "./CustomerBasicInfo.vue?vue&type=template&id=fffbbfe6&scoped=true&"
import script from "./CustomerBasicInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffbbfe6",
  null
  
)

export default component.exports